<template>
  <!-- Versão do fluxo de bot da conversa (cabeçalho do chat: gaveta e Modo Foco). A versão publicada é a que roda: publicou
       outra, a conversa passa pra ela na próxima mensagem — até lá, o aviso "atual vN". -->
  <span :class="['bvt', `bvt--${variant}`, { 'is-live': live, 'is-old': outdated }]" :title="tooltip">
    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <rect x="4" y="8" width="16" height="12" rx="3" /><path d="M12 8V4" /><circle cx="9" cy="14" r="1" /><circle cx="15" cy="14" r="1" />
    </svg>
    {{ label }}
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { ConversationBotInfo } from '@/services/wootdashConversations'

const props = withDefaults(defineProps<{ bot: ConversationBotInfo; variant?: 'dark' | 'light' }>(), { variant: 'light' })

const STATUS: Record<string, string> = {
  running: 'o bot está atendendo',
  handoff: 'passou para atendente',
  ended: 'o bot encerrou',
  expired: 'encerrada por tempo sem resposta',
}

const live = computed(() => props.bot.status === 'running')
const outdated = computed(() => props.bot.latestVersionNumber != null && props.bot.latestVersionNumber !== props.bot.versionNumber)
const what = computed(() => (props.bot.kind === 'rating' ? 'Avaliação' : 'Bot'))

const label = computed(() => {
  const version = `v${props.bot.versionNumber}`
  const base = live.value ? `${what.value} ${props.bot.botName} · ${version}` : props.bot.kind === 'rating' ? `Avaliação · ${version}` : `Passou pelo bot · ${version}`
  return outdated.value ? `${base} (atual v${props.bot.latestVersionNumber})` : base
})

const fmt = (iso: string) => new Date(iso).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' })

const tooltip = computed(() => {
  const b = props.bot
  const lines = [
    `${what.value}: ${b.botName}`,
    `Versão do fluxo: v${b.versionNumber} (publicada em ${fmt(b.versionPublishedAt)})`,
    `Começou em ${fmt(b.startedAt)} — ${STATUS[b.status] ?? b.status}`,
  ]
  if (b.waitingOn) lines.push(`Parado em: ${b.waitingOn}`)
  if (outdated.value) lines.push(live.value ? `Publicada a v${b.latestVersionNumber}: a conversa passa pra ela na próxima mensagem do contato.` : `Terminou na v${b.versionNumber}; a publicada agora é a v${b.latestVersionNumber}.`)
  return lines.join('\n')
})
</script>

<style scoped>
.bvt {
  display: inline-flex; align-items: center; gap: 4px; padding: 1px 7px; border-radius: 10px;
  font-size: 10px; font-weight: 700; white-space: nowrap; cursor: default; font-variant-numeric: tabular-nums;
}
.bvt--light { background: var(--ink-05); color: var(--ink-40); }
.bvt--light.is-live { background: rgba(13,148,136,.12); color: #0f766e; }
.bvt--dark { background: rgba(255,255,255,.12); color: rgba(255,255,255,.75); }
.bvt--dark.is-live { background: rgba(94,234,212,.22); color: #fff; }
.bvt.is-old { box-shadow: inset 0 0 0 1px rgba(217,119,6,.55); }
</style>
